import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppPageScript - the ONE inline script an archive contact page may carry, and the rule that takes it out again.
//
// ⭐ WHY A PAGE HAS A SCRIPT AT ALL (translation, owner 2026-09-27): a contact page in the subscriber's own Dropbox
// can be opened STANDALONE (double-clicked, shared, read in Dropbox's preview). A translated bubble's flag must show
// the original there too, and Copy must copy it - that needs a few lines of script. The page writes them inside
// `<script data-wac-standalone>...</script>` (`Open` + body + `Close`), and ONLY when it has a translated bubble.
//
// ⛔ THE APP REMOVES EXACTLY THAT SCRIPT before it builds the `blob:` frame (`Strip`), and attaches the same
// flag/Copy behaviour from outside (like `AppReactions`). The app's CSP allows no inline script, the frame shares the
// origin that can SEND, and a script from a file in a Dropbox folder must never run there. `Strip` removes only a
// block that opens with EXACTLY `Open` - any other `<script` is left as it is (the CSP refuses it anyway).
//
// ⚠ RULES ONLY - no DOM: the Bridge suite writes pages with `Open`/`Close` and asserts `Strip` takes them out
// byte-exactly (`TranslatePage.test.ts`).

export class AppPageScript {
    /** The marker attribute. */
    public static readonly Marker: string = "data-wac-standalone";
    /** ⛔ The EXACT opening tag the page writes and `Strip` looks for. */
    public static readonly Open: string = "<script " + AppPageScript.Marker + ">";
    public static readonly Close: string = "</script>";

    /** The page's text without any `Open` ... `Close` block (and nothing else changed). */
    public static Strip = (Html: string): string => {
        if (getCoreUtils().KErrorMode === true) { return nz(Html); }
        try {
            let Rest: string = nz(Html);
            let Out: string = "";
            let At: number = Rest.indexOf(AppPageScript.Open);
            while (At >= 0) {
                const End: number = Rest.indexOf(AppPageScript.Close, At + AppPageScript.Open.length);
                // ⚠ An unclosed block is cut to the end - an unterminated script would swallow the page anyway.
                if (End < 0) { return Out + Rest.substring(0, At); }
                Out = Out + Rest.substring(0, At);
                Rest = Rest.substring(End + AppPageScript.Close.length);
                At = Rest.indexOf(AppPageScript.Open);
            }
            return Out + Rest;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppPageScript.Strip");
            return nz(Html);
        }
    };

    /** Does the page carry a standalone script? DOCUMENTED EXCEPTION: pure. ERROR-SUPPRESSED-JUSTIFIED: pure. */
    public static Has = (Html: string): boolean => {
        return nz(Html).indexOf(AppPageScript.Open) >= 0;
    };
}
